import { Injectable } from "@angular/core";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { TradableService } from "./tradable.service";
import { Index } from "@models/asset/index/index.model";
import { debug } from "@helpers/debug";
import { SocketService } from "@main-services/socket.service";

@Injectable({
	providedIn: "root"
})
export class IndexService extends TradableService<Index> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, socketService, translationService, "IndexService");
	}

	public logoUrl(item: Index, grayVersion: boolean = false): string {
		let url = "assets/images/logos/index/";

		if (grayVersion) {
			url += item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "index-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to index updates");
		}

		const priceRoom = {
			room: "index_prices",
			collection: "indexes",
			type: Index,
			isPrivate: false
		};
		const assetRoom = {
			room: "indexes",
			collection: "indexes",
			type: Index,
			isPrivate: false
		};
		this.initSockets(priceRoom, assetRoom);
	}
}
